// Diccionario fuente (español). Cada clave usada via t('clave') desde useI18n().
// en.ts y zh.ts deben declarar TODAS estas claves (Record<TranslationKey, string>).
const es = {
  // ── Común ──────────────────────────────────────────────
  'common.refresh': 'Actualizar',
  'common.new': 'Nuevo',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.close': 'Cerrar',
  'common.loading': 'Cargando…',
  'common.all': 'Todos',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.active': 'Activo',
  'common.inactive': 'Inactivo',
  'common.discontinued': 'Descontinuado',
  'common.status': 'Estado',
  'common.actions': 'Acciones',
  'common.filters': 'Filtros',
  'common.category': 'Categoría',
  'common.brand': 'Marca',
  'common.name': 'Nombre',
  'common.price': 'Precio',
  'common.stock': 'Stock',
  'common.supplier': 'Proveedor',
  'common.product': 'Producto',
  'common.products': 'Productos',
  'common.date': 'Fecha',
  'common.client': 'Cliente',
  'common.total': 'Total',
  'common.previous': 'Anterior',
  'common.next': 'Siguiente',
  'common.pageOf': 'Página {page} de {pages} • Total: {total}',
  'common.allCategories': 'Todas las categorías',
  'common.allBrands': 'Todas las marcas',
  'common.allStatuses': 'Todos los estados',
  'common.user': 'Usuario',
  'common.role': 'Rol',
  'common.email': 'Correo electrónico',
  'common.optional': '(opcional)',
  'common.viewDetails': 'Ver detalles',
  'common.updateStatus': 'Actualizar estado',
  'common.error': 'Error',
  'common.remove': 'Quitar',

  // ── Roles ──────────────────────────────────────────────
  'role.superadmin': 'Superadmin',
  'role.admin': 'Admin',
  'role.client': 'Cliente',
  'role.viewer': 'Viewer',
  'role.superadminLong': 'Superadministrador',
  'role.adminLong': 'Administrador',

  // ── Layout admin ───────────────────────────────────────
  'nav.digestor': 'Digestor de Catálogos',
  'nav.inventory': 'Inventarios',
  'nav.suppliers': 'Proveedores',
  'nav.products': 'Productos',
  'nav.quotations': 'Pedidos & Cotizaciones',
  'nav.sales': 'Ventas',
  'nav.users': 'Usuarios',
  'nav.settings': 'Configuración',
  'layout.online': 'En línea',
  'layout.logout': 'Cerrar sesión',
  'layout.adminPanel': 'Admin Panel',
  'layout.language': 'Idioma',

  // ── Estados de pedido ──────────────────────────────────
  'status.pending': 'Pendiente',
  'status.confirmed': 'Confirmado',
  'status.processing': 'Procesando',
  'status.shipped': 'Enviado',
  'status.delivered': 'Entregado',
  'status.cancelled': 'Cancelado',
  'status.refunded': 'Reembolsado',

  // ── Estados de cotización ──────────────────────────────
  'qstatus.draft': 'Borrador',
  'qstatus.sent': 'Enviada',
  'qstatus.viewed': 'Vista',
  'qstatus.approved': 'Aprobada',
  'qstatus.rejected': 'Rechazada',
  'qstatus.expired': 'Vencida',
  'qstatus.converted': 'Convertida',

  // ── Disponibilidad de producto ─────────────────────────
  'avail.in_stock': 'En stock',
  'avail.low_stock': 'Stock bajo',
  'avail.out_of_stock': 'Agotado',
  'avail.discontinued': 'Descontinuado',
  'avail.pre_order': 'Pre-orden',

  // ── Inventario ─────────────────────────────────────────
  'inv.title': 'Gestión de Inventario',
  'inv.subtitle': 'Administra productos, stock y proveedores',
  'inv.export': 'Exportar',
  'inv.import': 'Importar',
  'inv.receipt': 'Recepción',
  'inv.history': 'Historial',
  'inv.newProduct': 'Nuevo Producto',
  'inv.alertsTitle': 'Alertas de stock:',
  'inv.alertsCount': '{count} productos con bajo stock o reorden',
  'inv.viewAlerts': 'Ver alertas',
  'inv.alertsModal': 'Alertas de Stock',
  'inv.colAvailable': 'Disponible',
  'inv.colMin': 'Mínimo',
  'inv.colReorder': 'Reorden',
  'inv.historyModal': 'Historial de Ajustes',
  'inv.colType': 'Tipo',
  'inv.colPrev': 'Previo',
  'inv.colNew': 'Nuevo',
  'inv.colReason': 'Motivo',
  'inv.receiptModal': 'Recepción de productos',
  'inv.reference': 'Referencia',
  'inv.refPlaceholder': 'OC/Factura/Guía',
  'inv.optionalMark': '(Opcional)',
  'inv.colProductId': 'Producto ID',
  'inv.colQuantity': 'Cantidad',
  'inv.addRow': 'Agregar fila',
  'inv.superTools': 'Herramientas de Superadmin',
  'inv.superOnly': 'Solo visibles para superadmin',
  'inv.wipeAll': 'Borrar inventario y productos',
  'inv.wipeMetrics': 'Borrar métricas generales',
  'inv.confirmWipe': '¿Seguro que deseas borrar TODO el inventario y TODOS los productos? (incluye stocks, ajustes, media y referencias). Esta acción no se puede deshacer.',
  'inv.confirmResetMetrics': '¿Resetear métricas generales del dashboard a cero?',
  'inv.wiped': 'Inventario borrado',
  'inv.wipeError': 'No se pudo borrar el inventario',
  'inv.metricsReset': 'Métricas reseteadas',
  'inv.metricsResetError': 'No se pudieron resetear las métricas',
  'inv.searchPh': 'Buscar productos por nombre o SKU...',
  'inv.itemsPerPage': 'Elementos por página',
  'inv.showing': 'Mostrando {from} - {to} de {total} productos',
  'inv.viewDetails': 'Ver detalles',
  'inv.adjustStock': 'Ajustar stock',
  'inv.moreOptions': 'Más opciones',
  'inv.stockOut': 'Sin Stock',
  'inv.stockLow': 'Stock Bajo',
  'inv.stockIn': 'En Stock',
  'inv.adjustTitle': 'Ajustar stock — {name}',
  'inv.adjType': 'Tipo',
  'inv.adjIn': 'Entrada',
  'inv.adjOut': 'Salida',
  'inv.adjSet': 'Fijar',
  'inv.adjNewStock': 'Nuevo stock',
  'inv.adjQuantity': 'Cantidad',
  'inv.adjReasonPh': 'Recepción, ajuste por conteo, merma, etc.',
  'inv.stockAdjusted': 'Stock ajustado',
  'inv.adjustError': 'No se pudo ajustar stock',
  'inv.deleteTitle': 'Eliminar producto',
  'inv.deleteConfirm': '¿Seguro que deseas eliminar este producto? Esta acción no se puede deshacer.',
  'inv.editTitle': 'Editar producto',
  'inv.reorderPoint': 'Punto de reorden',
  'inv.loadError': 'No se pudieron cargar los productos',
  'inv.updated': 'Producto actualizado',
  'inv.updateError': 'No se pudo actualizar',
  'inv.deleted': 'Producto eliminado',
  'inv.deleteError': 'No se pudo eliminar',
  'inv.receiptSaved': 'Recepción registrada',
  'inv.receiptError': 'No se pudo registrar la recepción',
  'inv.addValidRows': 'Agrega filas válidas',
  'inv.exportOk': 'Exportados {count} productos',
  'inv.exportError': 'No se pudo exportar',
  'inv.uploadOk': '✅ Inventario actualizado: {count} productos procesados correctamente',
  'inv.uploadError': 'Error al procesar el archivo',
  'inv.testOk': '✅ Test completado: {count} archivos procesados',
  'inv.testError': 'Error en el test de procesamiento',
  'inv.csvHeader': 'Nombre;SKU;Categoria;Marca;Precio;Stock;Proveedor;Estado',

  // ── Productos ──────────────────────────────────────────
  'prod.title': 'Productos',
  'prod.new': 'Nuevo Producto',
  'prod.searchPh': 'Buscar por nombre, SKU o marca',
  'prod.editTitle': 'Editar producto',
  'prod.newTitle': 'Nuevo producto',
  'prod.supplierRequired': 'Proveedor *',
  'prod.select': 'Seleccionar…',
  'prod.supplierCode': 'Código del proveedor',
  'prod.supplierSkuPh': 'SKU del proveedor',
  'prod.nameRequired': 'Nombre *',
  'prod.internalSku': 'SKU interno',
  'prod.categoryRequired': 'Categoría *',
  'prod.availability': 'Disponibilidad',
  'prod.none': 'No se encontraron productos',
  'prod.deleteTitle': 'Eliminar',
  'prod.deleteConfirm': '¿Confirmas eliminar este producto?',
  'prod.loadError': 'No se pudieron cargar los productos',
  'prod.updated': 'Producto actualizado',
  'prod.created': 'Producto creado',
  'prod.selectSupplier': 'Selecciona un proveedor',
  'prod.nameCatRequired': 'Nombre y categoría son obligatorios',
  'prod.saveError': 'No se pudo guardar',
  'prod.deleted': 'Producto eliminado',
  'prod.deleteError': 'No se pudo eliminar',
  'prod.tabMine': 'Mis productos',
  'prod.tabCatalog': 'Catálogo proveedores',
  'prod.catalogNote': 'Oferta importada de catálogos de proveedores por el Digestor — no es tu stock propio.',
  'prod.allSuppliers': 'Todos los proveedores',
  'prod.confidence': 'Confianza',
  'prod.catalogEmpty': 'Sin items en el catálogo — importa uno desde el Digestor',
  'prod.catalogSearchPh': 'Buscar en catálogo (nombre, SKU, spec)',

  // ── Proveedores ────────────────────────────────────────
  'sup.title': 'Proveedores',
  'sup.searchPh': 'Buscar por nombre o código',
  'sup.colCode': 'Código',
  'sup.colLastSync': 'Última sincronización',
  'sup.none': 'No se encontraron proveedores',
  'sup.editTitle': 'Editar proveedor',
  'sup.newTitle': 'Nuevo proveedor',
  'sup.activeField': 'Activo',
  'sup.loadError': 'No se pudieron cargar proveedores',
  'sup.nameCodeRequired': 'Nombre y código son obligatorios',
  'sup.saved': 'Proveedor guardado',
  'sup.saveError': 'No se pudo guardar',
  'sup.deleted': 'Proveedor eliminado',
  'sup.deleteError': 'No se pudo eliminar',

  // ── Pedidos & Cotizaciones ─────────────────────────────
  'quo.title': 'Pedidos & Cotizaciones',
  'quo.ordersTab': 'Pedidos ({count})',
  'quo.quotesTab': 'Cotizaciones ({count})',
  'quo.searchOrderPh': 'Buscar por número o cliente',
  'quo.searchQuotePh': 'Buscar por cliente o ID',
  'quo.colOrderNum': '# Orden',
  'quo.colValidUntil': 'Válida hasta',
  'quo.colCreated': 'Creada',
  'quo.noOrders': 'No hay pedidos',
  'quo.noQuotes': 'No hay cotizaciones registradas',
  'quo.orderModalTitle': 'Actualizar estado — {num}',
  'quo.quoteModalTitle': 'Actualizar cotización',
  'quo.ordersLoadError': 'No se pudieron cargar pedidos',
  'quo.quotesLoadError': 'No se pudieron cargar cotizaciones',
  'quo.statusUpdated': 'Estado actualizado',
  'quo.quoteStatusUpdated': 'Estado de cotización actualizado',
  'quo.updateError': 'No se pudo actualizar',

  // ── Cotizaciones del catálogo web (catalog_quote_requests) ──
  'cq.tab': 'Cotizaciones web',
  'cq.tabCount': 'Cotizaciones web ({count})',
  'cq.notifTitle': 'Notificaciones al recibir',
  'cq.notifAdminLabel': 'Aviso al equipo',
  'cq.notifClientLabel': 'Confirmación al cliente',
  'cq.notifAdminOk': '✓ equipo vía {via}',
  'cq.notifClientOk': '✓ cliente vía {via}',
  'cq.notifAdminNone': 'equipo sin notificar',
  'cq.notifAdminNoneTitle': 'Sin canal configurado o el envío falló — ver detalle',
  'cq.notifNone': 'no enviada',
  'cqstatus.nueva': 'Nueva',
  'cqstatus.enRevision': 'En revisión',
  'cqstatus.cotizada': 'Cotizada',
  'cqstatus.enviada': 'Enviada',
  'cqstatus.cerrada': 'Cerrada',
  'cq.searchPh': 'Buscar por número, cliente, email o WhatsApp',
  'cq.colNumber': 'N° Cotización',
  'cq.colContact': 'Contacto',
  'cq.colItems': 'Items',
  'cq.colEstTotal': 'Total est.',
  'cq.open': 'Abrir',
  'cq.empty': 'No hay solicitudes de cotización del catálogo',
  'cq.loadError': 'No se pudieron cargar las cotizaciones web',
  'cq.updateError': 'No se pudo actualizar la cotización',
  'cq.saved': 'Precios guardados',
  'cq.company': 'Empresa',
  'cq.clientNote': 'Nota del cliente',
  'cq.globalMargin': 'Margen global %',
  'cq.applyMargin': 'Aplicar precios',
  'cq.aiCalc': 'Calcular con IA (CortexBlood)',
  'cq.aiRunning': 'Consultando IA…',
  'cq.aiDone': 'Sugerencias de IA listas — revísalas y aplícalas',
  'cq.aiApply': 'Aplicar sugerencias IA',
  'cq.aiApplied': 'Sugerencias aplicadas a los precios',
  'cq.aiFailed': 'La IA no respondió ({reason}) — precios manuales disponibles',
  'cq.total': 'Total',
  'cq.colProduct': 'Producto',
  'cq.colQty': 'Cant.',
  'cq.colCost': 'Costo cat.',
  'cq.colMargin': 'Margen %',
  'cq.colSalePrice': 'P. Venta',
  'cq.colSubtotal': 'Subtotal',
  'cq.noBaseCost': 'Sin costo base — precio manual o sugerido por IA',
  'cq.sendWhatsApp': 'Enviar por WhatsApp',
  'cq.sendEmail': 'Enviar por Email',
  'cq.waTooltip': 'Abre WhatsApp con la cotización lista para el cliente',
  'cq.emailTooltipMailto': 'Abre tu cliente de correo con la cotización prellenada (servidor SMTP no configurado)',
  'cq.emailTooltipSmtp': 'Envía la cotización por el servidor SMTP',
  'cq.sentWhatsApp': 'Registrado como enviado por WhatsApp',
  'cq.sentEmail': 'Cotización enviada por email',
  'cq.sentEmailClient': 'Registrado — cotización enviada desde tu correo',
  'cq.emailFailed': 'No se pudo enviar el email',
  'cq.sentVia': 'enviada vía {via} {at}',
  'cq.pfTitle': 'Pre-factura (Proforma)',
  'cq.pfPending': 'Sin pre-factura — genérala para descargarla y enviarla al cliente',
  'cq.pfGenerate': 'Generar pre-factura PDF',
  'cq.pfGenerating': 'Generando PDF…',
  'cq.pfGenerated': 'Pre-factura {number} lista',
  'cq.pfError': 'No se pudo procesar la pre-factura',
  'cq.pfDownload': 'Descargar PDF',
  'cq.pfPublicLink': 'Link público del PDF',
  'cq.pfRefresh': 'Actualizar vista previa',
  'cq.qtyHint': 'Cantidad mayorista: botones ±1/±10/±100/±1000 o campo directo',

  // ── Ventas ─────────────────────────────────────────────
  'sales.title': 'Ventas',
  'sales.subtitle': 'Gestiona todos los pedidos y ventas de la plataforma',
  'sales.totalOrders': 'Total Pedidos',
  'sales.pending': 'Pendientes',
  'sales.totalRevenue': 'Ingresos Totales',
  'sales.thisMonth': 'Este Mes',
  'sales.searchPh': 'Buscar por número de pedido o cliente...',
  'sales.loadingOrders': 'Cargando pedidos...',
  'sales.noOrdersFiltered': 'No se encontraron pedidos con los filtros aplicados',
  'sales.noOrders': 'No hay pedidos registrados',
  'sales.colOrder': 'Pedido',
  'sales.colProducts': 'Productos',
  'sales.itemCount': '{count} producto(s)',
  'sales.pageInfo': 'Página {page} de {pages} • Total: {total} pedidos',
  'sales.modalTitle': 'Actualizar Estado del Pedido',
  'sales.orderLabel': 'Pedido:',
  'sales.clientLabel': 'Cliente:',
  'sales.newStatus': 'Nuevo Estado',
  'sales.tracking': 'Número de Seguimiento (opcional)',
  'sales.trackingPh': 'Ej: 1234567890',
  'sales.carrier': 'Transportadora (opcional)',
  'sales.carrierPh': 'Ej: DHL, FedEx, UPS',
  'sales.adminNotes': 'Notas Administrativas (opcional)',
  'sales.notesPh': 'Notas internas sobre el pedido...',
  'sales.updating': 'Actualizando...',
  'sales.updateBtn': 'Actualizar Estado',
  'sales.loadError': 'Error al cargar los datos de ventas',
  'sales.statusUpdated': 'Estado del pedido actualizado',
  'sales.updateError': 'Error al actualizar el estado del pedido',

  // ── Usuarios ───────────────────────────────────────────
  'users.title': 'Usuarios',
  'users.subtitle': 'Gestión de usuarios del sistema',
  'users.new': 'Nuevo Usuario',
  'users.searchPh': 'Buscar por nombre o email',
  'users.colLastLogin': 'Último login',
  'users.colCreated': 'Creado',
  'users.activeFilter': 'Activos',
  'users.inactiveFilter': 'Inactivos',
  'users.never': 'Nunca',
  'users.none': 'No se encontraron usuarios',
  'users.deactivate': 'Desactivar',
  'users.reactivate': 'Reactivar',
  'users.editTitle': 'Editar usuario',
  'users.newTitle': 'Nuevo usuario',
  'users.newPassword': 'Nueva contraseña (opcional)',
  'users.passwordRequired': 'Contraseña *',
  'users.firstName': 'Nombre *',
  'users.lastName': 'Apellido *',
  'users.loadError': 'No se pudieron cargar usuarios',
  'users.updated': 'Usuario actualizado',
  'users.created': 'Usuario creado',
  'users.required': 'Email, contraseña, nombre y apellido son obligatorios',
  'users.saveError': 'No se pudo guardar',
  'users.cantDeactivateSelf': 'No puedes desactivarte a ti mismo',
  'users.deactivated': 'Usuario desactivado',
  'users.reactivated': 'Usuario reactivado',
  'users.statusError': 'No se pudo cambiar el estado',

  // ── Configuración ──────────────────────────────────────
  'set.title': 'Configuración',
  'set.subtitle': 'Estado del sistema y cuenta',
  'set.systemStatus': 'Estado del sistema',
  'set.environment': 'Ambiente',
  'set.database': 'Base de datos',
  'set.verified': 'Verificado',
  'set.connected': 'Conectada',
  'set.noData': 'Sin datos',
  'set.dbRecords': 'Registros en base de datos',
  'set.yourAccount': 'Tu cuenta',
  'set.count.users': 'Usuarios',
  'set.count.suppliers': 'Proveedores',
  'set.count.products': 'Productos',
  'set.count.orders': 'Pedidos',
  'set.count.quotations': 'Cotizaciones',
  'set.count.inventory_items': 'Items de inventario',
  'set.count.catalog_items': 'Items del catálogo unificado',
  'set.loadError': 'No se pudo cargar la info del sistema',
  'set.uptime': 'Tiempo activo',

  // ── Login ──────────────────────────────────────────────
  'auth.brandTitle': 'Gestión gastronómica inteligente',
  'auth.brandDesc': 'Inventario, cotizaciones y pedidos en una sola plataforma. Diseñado para chefs y restaurantes de Latinoamérica.',
  'auth.f1Title': 'Inventario unificado',
  'auth.f1Desc': 'Control de stock en tiempo real',
  'auth.f2Title': 'Cotizaciones en minutos',
  'auth.f2Desc': 'Excel multi-formato con alta precisión',
  'auth.f3Title': 'Analíticas en vivo',
  'auth.f3Desc': 'Decisiones basadas en datos',
  'auth.welcome': 'Bienvenido de nuevo',
  'auth.welcomeSub': 'Accede a tu panel para gestionar inventario y cotizaciones',
  'auth.password': 'Contraseña',
  'auth.remember': 'Recuérdame',
  'auth.forgot': '¿Olvidaste tu contraseña?',
  'auth.signingIn': 'Iniciando sesión...',
  'auth.signIn': 'Iniciar sesión',
  'auth.or': 'o',
  'auth.createAccount': 'Crear cuenta nueva',
  'auth.loginError': 'Error al iniciar sesión',

  // ── Registro ───────────────────────────────────────────
  'reg.title': 'Crear cuenta',
  'reg.subtitle': 'Regístrate para comenzar a gestionar tu inventario',
  'reg.firstName': 'Nombre',
  'reg.lastName': 'Apellido',
  'reg.confirm': 'Confirmar contraseña',
  'reg.firstNameReq': 'Nombre es requerido',
  'reg.lastNameReq': 'Apellido es requerido',
  'reg.emailInvalid': 'Correo inválido',
  'reg.pwdMin': 'Mínimo 6 caracteres',
  'reg.pwdMismatch': 'Las contraseñas no coinciden',
  'reg.pwdHint': 'Usa mayúsculas, números y símbolos para mayor seguridad.',
  'reg.creating': 'Creando cuenta...',
  'reg.create': 'Crear cuenta',
  'reg.hasAccount': '¿Ya tienes cuenta?',
  'reg.signIn': 'Inicia sesión',
  'reg.created': 'Cuenta creada correctamente',

  // ── Recuperar contraseña ───────────────────────────────
  'fp.title': 'Recuperar contraseña',
  'fp.desc': 'Ingresa tu correo para enviarte un enlace de recuperación.',
  'fp.send': 'Enviar enlace',
  'fp.alert': 'Se enviará un enlace de recuperación a: {email} (demo)',

  // ── AuthLayout ─────────────────────────────────────────
  'authLayout.b1': 'Inventario unificado y cotizaciones en minutos',
  'authLayout.b2': 'Procesa Excel multi‑formato con alta precisión',
  'authLayout.b3': 'Medios optimizados y sincronizados para tu catálogo',

  // ── UploadWizard ───────────────────────────────────────
  'wiz.title': 'Importar Inventario (SAP‑style)',
  'wiz.supplierOptional': 'Proveedor (opcional)',
  'wiz.autoDetect': 'Auto‑detectar',
  'wiz.autoDetectHint': 'El sistema intentará detectar el formato automáticamente si no seleccionas proveedor.',
  'wiz.dropActive': 'Suelta los archivos aquí…',
  'wiz.dropIdle': 'Arrastra y suelta archivos Excel aquí o haz clic para seleccionar',
  'wiz.formats': 'Formatos: .xlsx, .xls • Máx 10MB por archivo',
  'wiz.colFile': 'Archivo',
  'wiz.colSize': 'Tamaño',
  'wiz.colStatus': 'Estado',
  'wiz.colProgress': 'Progreso',
  'wiz.emptyQueue': 'No hay archivos en la cola',
  'wiz.queued': 'En cola',
  'wiz.uploading': 'Subiendo',
  'wiz.processed': 'Procesado',
  'wiz.failed': 'Error',
  'wiz.summary': 'En cola: {q} • OK: {p} • Errores: {f}',
  'wiz.process': 'Procesar',
  'wiz.pause': 'Pausar',
  'wiz.clearQueue': 'Limpiar Cola',
  'wiz.results': 'Resultados',
  'wiz.colSupplier': 'Proveedor',
  'wiz.colProducts': 'Productos',
  'wiz.colTime': 'Tiempo',
  'wiz.uploadError': 'Error subiendo archivo',

  // ── Digestor de catálogos (CortexCatalogProcessorPage) ──
  'digest.title': 'Digestor Masivo de Catálogos',
  'digest.formatsBadge': 'Excel · CSV · TXT · PDF · Word · Imágenes + IA Local',
  'digest.subtitle': 'Sube lotes de listas de precios en cualquier formato/idioma. El motor determinista + CortexBlood AI los normaliza, deduplica y unifica en el catálogo global.',
  'digest.aiBadgeSession': 'Sin respuesta del API (sesión)',
  'digest.aiBadgeLatency': 'latencia {ms}ms',
  'digest.aiBadgeOffline': 'CortexBlood no responde — solo motor determinista',
  'digest.dropReady': '{n} archivo(s) listos para digerir',
  'digest.dropHint': 'Arrastra lotes de catálogos o haz clic',
  'digest.dropFormats': '.xlsx .xls .csv .txt .pdf .docx .png .jpg — cualquier encoding o idioma',
  'digest.digestBtn': 'Digerir {n} archivo(s)',
  'digest.digesting': 'Digiriendo lote…',
  'digest.addFileErr': 'Agrega al menos un archivo de catálogo',
  'digest.tooLarge': 'Archivo(s) rechazado(s) por tamaño (máx {max}MB): {names}',
  'digest.jobQueued': 'Lote encolado: {n} archivos — puedes cerrar esta pestaña, el proceso continúa en el servidor',
  'digest.jobDone': 'Lote terminado: {ok}/{total} archivos OK, {n} productos insertados',
  'digest.tabCloseNote': 'El procesamiento corre en el servidor: si cierras la pestaña puedes seguir el estado en la lista de jobs.',
  'digest.uploadMB': '{loaded} / {total} MB',
  'digest.uploading': 'Subiendo {pct}%',
  'digest.stage.queued': 'En cola',
  'digest.stage.reading': 'Leyendo documento',
  'digest.stage.extracting': 'Extrayendo productos',
  'digest.stage.enriching': 'Enriqueciendo con IA',
  'digest.stage.ocr': 'OCR por visión',
  'digest.stage.images': 'Extrayendo fotos',
  'digest.stage.persisting': 'Guardando en catálogo',
  'digest.stage.pages': 'página {done}/{total}',
  'digest.stage.ai': 'IA {done}/{total}',
  'digest.stage.inserted': '{n} guardados',
  'digest.stage.products': '{n} productos',
  'digest.stage.imagesMatched': '{n} fotos',
  'digest.jobCompleted': 'Completado',
  'digest.jobFailed': 'Falló',
  'digest.jobProcessing': 'Procesando',
  'digest.jobSummary': '{ok}/{total} OK · {failed} fallidos · {inserted} insertados · {dupes} duplicados',
  'digest.jobProducts': '{n} prod',
  'digest.hybridTag': 'Motor Híbrido Determinista + IA',
  'digest.hybridTitle': 'Tolerante a caos real de proveedores',
  'digest.hybridBody': 'Sin orden fijo de columnas. Detecta encabezados en cualquier fila, sinónimos ES/EN/ZH (品名, precio, SKU, 单价…), encodings UTF-8/Latin-1/GBK, filas promocionales, y si la confianza es baja invoca el LLM local (Ollama). Cada lote pasa por CortexBlood: nombres traducidos y canonicalizados, categorías unificadas, y después un scan semántico detecta duplicados que el hash no atrapa.',
  'digest.featBatch': 'Batch',
  'digest.featBatchBody': '100+ archivos por lote, falla aislada por archivo',
  'digest.featDedup': 'Dedupe IA',
  'digest.featDedupBody': 'Hash exacto + confirmación semántica por LLM',
  'digest.featAI': 'IA Siempre',
  'digest.featAIBody': 'CortexBlood enriquece y traduce cada producto',
  'digest.dedupTitle': 'Duplicados detectados por IA',
  'digest.dedupSub': 'Segunda pasada CortexBlood sobre el catálogo — corre sola tras cada lote · mismo producto, distinto nombre/proveedor',
  'digest.dedupScanning': 'analizando {items} items · {ok}/{total} grupos…',
  'digest.dedupBtn': 'Escanear con CortexBlood',
  'digest.dedupEmptyDone': 'Scan completado — sin duplicados semánticos confirmados',
  'digest.dedupEmpty': 'Sin grupos pendientes. Lanza el scan IA para detectar duplicados semánticos.',
  'digest.dedupMerge': 'Fusionar',
  'digest.dedupDismiss': 'No son dup',
  'digest.dedupCanonical': 'canónico',
  'digest.dedupDupPct': '{pct}% dup',
  'digest.dedupScanToast': 'Scan IA: {ok} grupos duplicados de {total} candidatos',
  'digest.dedupScanFail': 'Scan IA falló: {err}',
  'digest.dedupScanStart': 'CortexBlood escaneando duplicados semánticos…',
  'digest.dedupLaunchFail': 'No se pudo lanzar el scan',
  'digest.dedupMerged': 'Fusionado: {n} items absorbidos',
  'digest.dedupDismissed': 'Grupo descartado',
  'digest.dedupResolveFail': 'No se pudo resolver',
  'digest.netError': 'Error de red: {err}',
  'digest.catalogTitle': 'Catálogo Unificado',
  'digest.catalogStats': '{items} productos · {suppliers} proveedores',
  'digest.catalogAiItems': '{n} normalizados por IA',
  'digest.searchPlaceholder': 'Buscar nombre / SKU / spec…',
  'digest.allSuppliers': 'Todos los proveedores',
  'digest.allCategories': 'Todas las categorías',
  'digest.filterBtn': 'Filtrar',
  'digest.colProduct': 'Producto',
  'digest.colSku': 'SKU',
  'digest.colSupplier': 'Proveedor',
  'digest.colCategory': 'Categoría',
  'digest.colSpec': 'Spec / Cap / Potencia',
  'digest.colPrice': 'Precio USD',
  'digest.colStock': 'Stock',
  'digest.colConf': 'Conf.',
  'digest.colSource': 'Origen',
  'digest.catalogEmpty': 'Sin productos. Digierie un lote de catálogos arriba.',
  'digest.pagination': '{total} productos · página {page} de {pages}',
  'digest.prevPage': '← Anterior',
  'digest.nextPage': 'Siguiente →',
  'digest.aiExtractTitle': 'Extracción completa por LLM',
  'digest.aiEnhanceTitle': 'Productos normalizados/enriquecidos por CortexBlood',
  // Errores específicos (errorCode del backend → i18n)
  'digest.err.pdfScanned': 'PDF escaneado sin capa de texto — requiere OCR por visión',
  'digest.err.pdfPassword': 'PDF protegido con contraseña — quita la clave y vuelve a subirlo',
  'digest.err.pdfCorrupt': 'PDF corrupto o truncado',
  'digest.err.pdfUnreadable': 'El PDF no se pudo leer',
  'digest.err.unsupported': 'Tipo de archivo no soportado para digestión',
  'digest.err.badSpreadsheet': 'No se pudo leer como hoja de cálculo',
  'digest.err.badDocx': 'No se pudo leer el documento Word',
  'digest.err.fileUnreadable': 'El archivo no se pudo leer del disco',
  'digest.err.interrupted': 'Interrumpido por reinicio del servicio — vuelve a subirlo',
  'digest.err.empty': 'No se pudo extraer ninguna tabla legible del archivo',
  'digest.err.noProducts': 'No se encontraron productos en el archivo',
  'digest.err.unknown': 'Error de extracción desconocido',
  'digest.err.tooLargeHttp': 'El archivo excede el límite del servidor ({max}MB por archivo)',
  'digest.err.timeout': 'La subida tardó demasiado — conexión lenta o archivo muy grande',
  'digest.err.network': 'Sin conexión con el servidor — verifica tu red',
  'digest.err.batch': 'Error al encolar lote (HTTP {status})',
  // ── Prospectos ──
  'nav.prospects': 'Prospectos',
  'nav.cotizaia': 'cotizaIA',
  'pros.title': 'Clientes Potenciales',
  'pros.aiOnline': 'en línea',
  'pros.aiOffline': 'caída',
  'pros.hideSearch': 'Ocultar búsqueda',
  'pros.newSearch': 'Nueva búsqueda',
  'pros.discoverTitle': 'Descubrir prospectos en América',
  'pros.stepCountry': '1. País',
  'pros.stepRegion': '2. {label}',
  'pros.selectRegion': '— Selecciona {label} —',
  'pros.stepCities': '3. Ciudades',
  'pros.citiesIn': '({n} en {province})',
  'pros.pickRegionFirst': '↑ Primero selecciona {label}',
  'pros.stepSegments': '4. Segmentos',
  'pros.stepKeywords': '5. Palabras clave (opcional, separadas por coma)',
  'pros.keywordsPh': 'mariscos, pizza, sushi…',
  'pros.stepLimit': '6. Límite: {n} prospectos',
  'pros.allCountries': 'Todos los países',
  'pros.colCountry': 'País',
  'pros.searching': 'Buscando…',
  'pros.searchIn': 'Buscar en {n} {cities}',
  'pros.cityOne': 'ciudad',
  'pros.cityMany': 'ciudades',
  'pros.sourcesNote': 'Fuentes gratuitas: OpenStreetMap/Overpass + búsqueda web · scoring con CortexBlood',
  'pros.starting': 'Iniciando…',
  'pros.progress': 'Ciudades {done}/{total} · {found} prospectos encontrados',
  'pros.resultSummary': '{inserted} nuevos · {found} encontrados · {duplicates} ya existían · {scored} puntuados con IA',
  'pros.aiUnavailable': ' · IA no disponible (sin score)',
  'pros.sourcesFailed': 'Fuentes sin respuesta: {list}',
  'pros.searchFailed': 'La búsqueda falló',
  'pros.totalCount': '{n} prospectos',
  'pros.plural': 'prospectos',
  'pros.withScore': 'con fit_score',
  'pros.avgScore': ' (promedio {avg})',
  'pros.searchPh': 'Buscar por nombre, dirección o cocina',
  'pros.allSegments': 'Todos los segmentos',
  'pros.scoreAll': 'Score: todos',
  'pros.colBusiness': 'Negocio',
  'pros.colSegment': 'Segmento',
  'pros.colCity': 'Ciudad',
  'pros.colContact': 'Contacto',
  'pros.colScore': 'Fit score',
  'pros.empty': 'Sin prospectos — lanza una búsqueda arriba',
  'pros.noScore': 'Sin score de IA',
  'pros.aiReasonNotes': 'Motivo IA y notas',
  'pros.aiAnalysis': 'Análisis IA',
  'pros.noAnalysis': 'Sin análisis — la IA no estaba disponible al descubrirlo',
  'pros.source': 'Fuente: {src}',
  'pros.notes': 'Notas',
  'pros.notesPh': 'Seguimiento, contacto, próximos pasos…',
  'pros.saveNote': 'Guardar nota',
  'pros.noteSaved': 'Nota guardada',
  'pros.pagination': '{total} prospectos · página {page} de {pages}',
  'pros.loadError': 'No se pudieron cargar prospectos',
  'pros.cityRequired': 'Selecciona al menos una ciudad',
  'pros.segmentRequired': 'Selecciona al menos un segmento',
  'pros.searchStarted': 'Búsqueda iniciada — esto puede tardar unos minutos',
  'pros.searchStartError': 'No se pudo iniciar la búsqueda',
  'pros.updateError': 'No se pudo actualizar',
  'pros.jobDone': '{inserted} prospectos nuevos ({found} encontrados)',
  'pros.jobDoneScored': ', {scored} puntuados con IA',
  'pros.statusChanged': 'Estado → {status}',
  'pros.approach': 'Enfoque',
  'pstatus.new': 'Nuevo',
  'pstatus.contacted': 'Contactado',
  'pstatus.qualified': 'Calificado',
  'pstatus.discarded': 'Descartado',

  // ── Catálogo admin (CatalogPage) ──
  'nav.catalog': 'Catálogo',
  'cat.title': 'Catálogo',
  'cat.subtitle': 'Todo lo digerido de catálogos de proveedores — filtra por cada característica',
  'cat.searchPh': 'Buscar por nombre, SKU o spec…',
  'cat.moreFilters': 'Más filtros',
  'cat.brandPh': 'Marca (en nombre o spec)',
  'cat.capacity': 'Capacidad',
  'cat.capacityPh': 'Ej: 16L, 350ml',
  'cat.power': 'Potencia',
  'cat.powerPh': 'Ej: 410W, 60,000 BTU',
  'cat.dimensions': 'Dimensiones',
  'cat.dimensionsPh': 'Ej: 120 x 90',
  'cat.unit': 'Unidad',
  'cat.allUnits': 'Todas las unidades',
  'cat.priceMin': 'Precio mín. (USD)',
  'cat.priceMax': 'Precio máx. (USD)',
  'cat.confAny': 'Cualquier confianza',
  'cat.confMid': 'Media o alta (≥50%)',
  'cat.confHigh': 'Solo alta (≥80%)',
  'cat.hasImage': 'Con foto',
  'cat.inStock': 'Con stock',
  'cat.clear': 'Limpiar filtros',
  'cat.loadError': 'No se pudo cargar el catálogo',
  'cat.empty': 'Sin resultados con estos filtros — ajusta la búsqueda',
  'cat.pagination': '{total} productos · página {page} de {pages}',
  'cat.noPhoto': 'Sin foto',
  'cat.askPrice': 'Consultar',


  // ── Logística de despacho (descubrimiento de proveedores) ──
  'logi.aiAnalysis': 'Análisis IA',
  'logi.aiOffline': 'offline',
  'logi.aiOnline': 'online',
  'logi.aiReasonNotes': 'Razón IA y notas',
  'logi.aiUnavailable': 'IA no disponible — resultados sin scoring',
  'logi.allCountries': 'Todos los países',
  'logi.allTypes': 'Todos los tipos',
  'logi.approach': 'Enfoque',
  'logi.avgScore': 'score medio {avg}',
  'logi.channelActive': 'Marcar canal activo',
  'logi.citiesIn': '({n} en {province})',
  'logi.cityMany': 'ciudades',
  'logi.cityOne': 'ciudad',
  'logi.cityRequired': 'Selecciona al menos una ciudad',
  'logi.colCity': 'Ciudad',
  'logi.colContact': 'Contacto',
  'logi.colCountry': 'País',
  'logi.colProvider': 'Proveedor',
  'logi.colScore': 'Score',
  'logi.colType': 'Tipo',
  'logi.discoverTitle': 'Descubrir proveedores de despacho',
  'logi.empty': 'Sin proveedores — lanza un descubrimiento arriba',
  'logi.hideSearch': 'Ocultar búsqueda',
  'logi.jobDone': '{inserted} nuevos de {found} encontrados',
  'logi.jobDoneScored': ' · {scored} con score IA',
  'logi.keywordsPh': 'ej. delivery, moto, mensajería',
  'logi.loadError': 'No se pudieron cargar los proveedores',
  'logi.newSearch': 'Nueva búsqueda',
  'logi.noAnalysis': 'Sin análisis IA',
  'logi.noScore': 'Sin score',
  'logi.notes': 'Notas',
  'logi.noteSaved': 'Nota guardada',
  'logi.notesPh': 'Nota interna…',
  'logi.pagination': '{total} proveedores · página {page} de {pages}',
  'logi.pickRegionFirst': 'Elige una {label} primero',
  'logi.plural': 'proveedores',
  'logi.progress': '{done}/{total} ciudades · {found} encontrados',
  'logi.resultSummary': '{inserted} insertados · {found} encontrados · {duplicates} duplicados · {scored} con score',
  'logi.saveNote': 'Guardar',
  'logi.scoreAll': 'Todos los scores',
  'logi.searchFailed': 'La búsqueda falló',
  'logi.searchIn': 'Buscar en {n} {cities}',
  'logi.searching': 'Buscando…',
  'logi.searchPh': 'Buscar proveedor…',
  'logi.searchStarted': 'Descubrimiento iniciado',
  'logi.searchStartError': 'No se pudo iniciar el descubrimiento',
  'logi.selectRegion': 'Selecciona {label}',
  'logi.source': 'Fuente: {src}',
  'logi.sourcesFailed': 'Fuentes fallidas: {list}',
  'logi.sourcesNote': 'Fuentes: directorios públicos, mapas y web local (solo datos públicos)',
  'logi.starting': 'Iniciando…',
  'logi.statusChanged': 'Estado → {status}',
  'logi.stepCities': 'Ciudades',
  'logi.stepCountry': 'País',
  'logi.stepKeywords': 'Keywords (opcional)',
  'logi.stepLimit': 'Límite por ciudad: {n}',
  'logi.stepRegion': '{label}',
  'logi.stepTypes': 'Tipos de proveedor',
  'logi.title': 'Logística de despacho',
  'logi.typeRequired': 'Selecciona al menos un tipo de proveedor',
  'logi.updateError': 'No se pudo actualizar',
  'logi.withScore': 'con score',
  'lstatus.new': 'Nuevo',
  'lstatus.contacted': 'Contactado',
  'lstatus.negotiating': 'Negociando',
  'lstatus.active_channel': 'Canal activo',
  'lstatus.discarded': 'Descartado',

  // ── Upload wizard (importar inventario) ──

} as const

export type TranslationKey = keyof typeof es
export default es
